import { postData } from '../modules/fetch';
import { logMessage } from '../logger';

const postReply = (id: string, requestBody, successCallback, errorCallback) => {
  return postData(`/reviews/${id}/replies`, requestBody, false)
    .then((data) => {
      if (data) {
        logMessage(data);
        successCallback(data);
      }
    })
    .catch((err) => {
      console.error(err);
      errorCallback(err);
    });
};

export default postReply;
